/* eslint-disable react-hooks/exhaustive-deps */
import BaseLayout from "../Layout/BaseLayout";
import {
  Divider,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Spinner,
} from "@nextui-org/react";
import { useTranslation } from "react-i18next";
import PaginationBasic from "../Components/PaginationBasic";
import { ItemContainer } from "../Components/ItemContainer";
import { useApi } from "../Context/ApiProvider";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { Helmet } from "react-helmet";

export default function BlogPage() {
  const { t } = useTranslation();
  const api = useApi();
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [tags, setTags] = useState([]);
  const [selectedArticleType, setSelectedArticleType] = useState(null);
  const [searchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [totalCount, setTotalCount] = useState(0); // Total product count
  const [menuOpen, setMenuOpen] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [seoData, setSeoData] = useState({
    seo_title: "",
    search_description: "",
  });

  const articlesType = [
    { id: 1, topic: t("post"), image: "/Assets/Images/Product1.jpg" },
    { id: 2, topic: t("News"), image: "/Assets/Images/Product2.jpg" },
  ];

  // Fetch blog posts
  useEffect(() => {
    (async () => {
      const query = {
        limit: 10,
        offset: (currentPage - 1) * 10,
      };
      setLoadingPage(true);
      const resPosts = await api.uget("/api/blog/posts", query);
      if (resPosts.ok && resPosts.body && resPosts.body.results) {
        setTotalCount(resPosts.body.count);
        const fetchedPosts = resPosts.body.results.map((item) => ({
          id: item.id,
          name: item.title,
          image: item.featured_image ? item.featured_image.url : null,
          text: item.excerpt,
          tags: item.tags || [],
          lastPublishedAt: item.last_published_at,
          type: item.type,
        }));
        setPosts(fetchedPosts);
        const allTags = [...new Set(fetchedPosts.flatMap((post) => post.tags))];
        setTags(allTags);
        setSeoData({
          seo_title: fetchedPosts.seo_title,
          search_description: fetchedPosts.search_description,
        });
      }
      setLoadingPage(false);
    })();
  }, [api, currentPage]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  // Filter posts based on selected type and search term
  const filteredPosts = posts.filter((item) => {
    const matchSearchTerm = item.name
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchArticleType = selectedArticleType
      ? item.type === "post" && selectedArticleType.id === 1
      : true; // Filter by type if selected
    return matchSearchTerm && matchArticleType;
  });

  return (
    <BaseLayout>
      <Helmet>
        <title>{seoData.seo_title || t("menuBlog")}</title>
        <meta name="description" content={seoData.search_description} />
      </Helmet>
      <Swiper
        dir="ltr"
        className="h-[20rem] lg:h-[40rem] mt-10 lg:mt-0 "
        loop={true}
        navigation={true}
        modules={[Navigation]}
      >
        <div className=" absolute top-[60%] right-0 lg:right-[25%] transform -translate-x-1/2 -translate-y-1/2 z-10 space-x-4 flex flex-col lg:flex-row-reverse gap-3 items-center text-center">
          <div className="leading-loose text-white ">
            <h1 className="text-xl  2xl:text-3xl font-bold ">
              {t("menuBlog")}
            </h1>
            <Divider className="bg-red-600 h-1  my-2" />

            <div
              className={`bg-white px-5 py-2 rounded-md   flex justify-center items-center w-full whitespace-nowrap${
                localStorage.getItem("lng") === "fa"
                  ? "rtl flex-row-reverse"
                  : localStorage.getItem("lng") === "en"
                  ? "ltr"
                  : ""
              }`}
            >
              <div
                className="text-sm text-gray-600 cursor-pointer "
                onClick={() => navigate("/")}
              >
                {t("menuHome")}
              </div>
              <span className="px-2 text-black">/</span>
              <div>
                <span className="text-[15px] font-bold text-black">
                  {t("menuBlog")}
                </span>
              </div>
            </div>
          </div>
        </div>

        <SwiperSlide key={1}>
          <img
            src="/Assets/Images/Blog.jpg"
            className="w-[60%] h-full hidden lg:block  "
            alt="1"
            style={{
              WebkitMaskImage:
                "linear-gradient(to right, black 85%, transparent 100%)",
              maskImage:
                "linear-gradient(to right, black 80%, transparent 100%)",
            }}
          />
          <img
            src="/Assets/Images/Blog.jpg"
            className="w-full h-full lg:hidden "
            alt="1"
          />
          <div className="absolute top-0  w-full h-full bg-gradient-to-l from-primary-900 to-transparent opacity-90" />
        </SwiperSlide>
      </Swiper>
      {!posts || !tags || loadingPage ? (
        <Spinner size="lg" className="flex justify-center mt-16 mb-16" />
      ) : (
        <div className="flex flex-col  gap-5  items-center  justify-center lg:w-[70%]  m-auto p-5 lg:p-0 mt-5 lg:mt-14">
          <div className=" text-black  w-full ">
            <div
              className="bg-white flex gap-1 items-center p-4 rounded-lg"
              onChange={() => setMenuOpen(!menuOpen)}
            >
              <Dropdown className="absolute">
                <DropdownTrigger
                  className="cursor-pointer hover:text-primary  "
                  isOpen={menuOpen}
                >
                  <div className="flex items-center gap-1">
                    {t("articlesType")}
                    <ChevronDownIcon className="w-4 h-4 animate-pulse mb-1 cursor-pointer  hover:text-primary" />
                  </div>
                </DropdownTrigger>
                <DropdownMenu
                  dir="rtl"
                  className="bg-white text-black "
                  aria-label="articlesType"
                  onAction={(key) => setSelectedArticleType(key)}
                >
                  <DropdownItem
                    color="primary"
                    onAction={(key) => {
                      if (key === "all") {
                        setSelectedArticleType(null);
                      } else {
                        const selectedType = articlesType.find(
                          (type) => type.id === parseInt(key)
                        );
                        setSelectedArticleType(selectedType);
                      }
                    }}
                  >
                    {t("All")}
                  </DropdownItem>
                  {articlesType.map((articles) => (
                    <DropdownItem color="primary" key={articles.id}>
                      {articles.topic}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>

          <div className=" lg:mt-2 grid  relative z-30 mb-5 ">
            <div className="w-full h-auto grid sm:grid-cols-2 xl:grid-cols-3 gap-5">
              {filteredPosts.length > 0 ? (
                filteredPosts.map((item) => (
                  <ItemContainer
                    key={item.id}
                    topic={item.name}
                    text={item.text}
                    img={item.image}
                    lastpublishedAt={
                      localStorage.getItem("lng") === "fa"
                        ? new Date(item.lastPublishedAt).toLocaleDateString(
                            "fa-IR"
                          )
                        : new Date(item.lastPublishedAt).toLocaleDateString()
                    } // Pass formatted date
                    blogPost={item}
                    isBlogPost={true}
                  />
                ))
              ) : (
                <div className="col-span-3 text-center mt-5">
                  <p className="text-lg text-gray-600">{t("noPostsFound")}</p>
                </div>
              )}
            </div>
            {filteredPosts.length > 0 && (
              <div className="flex justify-center relative z-50 ">
                <PaginationBasic
                  currentPage={currentPage}
                  totalItems={totalCount}
                  itemsPerPage={10}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </BaseLayout>
  );
}
